import React from 'react';

import { ScrollDirection } from '~/react-hooks/use-scroll-direction';

export interface TypeformContextArgs {
  scrollToNextStep(): void;
  scrollToPrevStep(): void;
  scrollDirection?: ScrollDirection;
}

export default React.createContext<TypeformContextArgs>({
  scrollToNextStep: () => undefined,
  scrollToPrevStep: () => undefined,
});
